import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const getMe: UseCase<AuthRepository, 'getMe'> = (repository) => {
  return async () => {
    return await repository.getMe()
  }
}
